import { Route } from "react-router-dom";
import { AdminLayout } from "@/components/layout";
import {
  AdminDashboardScreen,
  AdminProductsScreen,
  ProductFormScreen,
  AdminOrdersScreen,
  OrderDetailScreen,
  AdminUsersScreen,
  AdminCustomersScreen,
  AdminTransactionsScreen,
  AdminServiceRequestsScreen,
  AdminServiceRequestDetailScreen,
  MediaManagerScreen,
  AdminFAQScreen,
  AnalyticsScreen,
  StockManagementScreen,
  AdminProfileScreen,
  AdminSettingsScreen,
  AdminTestimonialsScreen,
  AdminDealsScreen,
  DealFormScreen,
  AdminCategoriesScreen,
  CategoryFormScreen,
  AdminNewsletterSubscribersScreen,
  AdminCreateOrderScreen,
  AdminCouponsScreen,
} from "@/screens/admin";
import { AdminProtectedRoute } from "@/components/auth";

export const adminRoutes = [
  <Route
    key="admin-layout"
    path="/admin"
    element={
      <AdminProtectedRoute>
        <AdminLayout />
      </AdminProtectedRoute>
    }
  >
    <Route index element={<AdminDashboardScreen />} />
    <Route path="analytics" element={<AnalyticsScreen />} />
    <Route path="categories" element={<AdminCategoriesScreen />} />
    <Route path="categories/new" element={<CategoryFormScreen />} />
    <Route path="categories/:id/edit" element={<CategoryFormScreen />} />
    <Route path="products" element={<AdminProductsScreen />} />
    <Route path="products/new" element={<ProductFormScreen />} />
    <Route path="products/:id/edit" element={<ProductFormScreen />} />
    <Route path="deals" element={<AdminDealsScreen />} />
    <Route path="deals/new" element={<DealFormScreen />} />
    <Route path="deals/:id/edit" element={<DealFormScreen />} />
    <Route path="coupons" element={<AdminCouponsScreen />} />
    <Route path="stock" element={<StockManagementScreen />} />
    <Route path="orders" element={<AdminOrdersScreen />} />
    <Route path="orders/create" element={<AdminCreateOrderScreen />} />
    <Route path="orders/:id" element={<OrderDetailScreen />} />
    <Route path="users" element={<AdminUsersScreen />} />
    <Route path="customers" element={<AdminCustomersScreen />} />
    <Route path="transactions" element={<AdminTransactionsScreen />} />
    <Route path="service-requests" element={<AdminServiceRequestsScreen />} />
    <Route
      path="service-requests/:id"
      element={<AdminServiceRequestDetailScreen />}
    />
    <Route path="media" element={<MediaManagerScreen />} />
    <Route path="faq" element={<AdminFAQScreen />} />
    <Route path="testimonials" element={<AdminTestimonialsScreen />} />
    <Route path="newsletter" element={<AdminNewsletterSubscribersScreen />} />
    <Route path="profile" element={<AdminProfileScreen />} />
    <Route path="settings" element={<AdminSettingsScreen />} />
  </Route>,
];
